module.exports = __webpack_public_path__ + "media/images/photos/switzerland-efe44159b015dceec7ee8dfb1a9a696c.jpg";